// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__AeXsk","title":"FrontImage_title__20yOl"};